(function () {
  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function updatePinState(lockSection) {
    var sticky = lockSection.querySelector('.lock-scenes-2026__sticky');
    if (!sticky) {
      return;
    }

    var style = window.getComputedStyle(lockSection);
    var headerOffset = parseFloat(style.getPropertyValue('--lock-header-offset')) || 100;
    var rawViewH = window.innerHeight || document.documentElement.clientHeight;
    var stickyH = Math.max(rawViewH - headerOffset, 1);
    var rect = lockSection.getBoundingClientRect();
    var sectionH = lockSection.offsetHeight;
    var sectionTopInDoc = window.pageYOffset + rect.top;
    var pinStart = sectionTopInDoc - headerOffset;
    var pinEnd = pinStart + Math.max(sectionH - stickyH, 0);
    var y = window.pageYOffset;

    sticky.style.height = stickyH + 'px';

    if (y < pinStart) {
      sticky.style.position = 'absolute';
      sticky.style.top = '0';
      sticky.style.left = '0';
      sticky.style.width = '100%';
    } else if (y >= pinEnd) {
      sticky.style.position = 'absolute';
      sticky.style.top = Math.max(sectionH - stickyH, 0) + 'px';
      sticky.style.left = '0';
      sticky.style.width = '100%';
    } else {
      sticky.style.position = 'fixed';
      sticky.style.top = headerOffset + 'px';
      sticky.style.left = rect.left + 'px';
      sticky.style.width = rect.width + 'px';
    }
  }

  function updateSection(lockSection) {
    var scenes = lockSection.querySelectorAll('.lock-scenes-2026__scene');
    if (!scenes.length) {
      return;
    }

    updatePinState(lockSection);

    var rect = lockSection.getBoundingClientRect();
    var style = window.getComputedStyle(lockSection);
    var headerOffset = parseFloat(style.getPropertyValue('--lock-header-offset')) || 100;
    var rawViewH = window.innerHeight || document.documentElement.clientHeight;
    var viewH = Math.max(rawViewH - headerOffset, 1);
    var sectionH = lockSection.offsetHeight;
    var scrollable = sectionH - viewH;
    var progress = 0;

    if (scrollable > 0) {
      progress = clamp(-rect.top / scrollable, 0, 1);
    } else {
      progress = rect.top <= 0 ? 1 : 0;
    }

    var maxIndex = scenes.length - 1;
    var position = progress * maxIndex;
    var baseIndex = Math.floor(position);
    var local = position - baseIndex;
    var blendWindow = 0.22;
    var blendStart = (1 - blendWindow) / 2;
    var blendEnd = blendStart + blendWindow;
    var blend = 0;

    if (maxIndex <= 0) {
      blend = 0;
      baseIndex = 0;
    } else if (local <= blendStart) {
      blend = 0;
    } else if (local >= blendEnd) {
      blend = 1;
    } else {
      blend = (local - blendStart) / blendWindow;
    }

    var nextIndex = clamp(baseIndex + 1, 0, maxIndex);
    var isTransitioning = maxIndex > 0 && blend > 0 && blend < 1;

    for (var i = 0; i < scenes.length; i += 1) {
      var opacity = 0;
      if (i === baseIndex) {
        opacity = 1 - blend;
      }
      if (i === nextIndex) {
        opacity = Math.max(opacity, blend);
      }

      scenes[i].style.opacity = opacity.toFixed(3);

      if (isTransitioning && opacity > 0) {
        var brightness = 0.78 + opacity * 0.22;
        scenes[i].style.filter = 'brightness(' + brightness.toFixed(3) + ')';
      } else {
        scenes[i].style.filter = 'none';
      }

      if (opacity > 0.5) {
        scenes[i].classList.add('is-active');
      } else {
        scenes[i].classList.remove('is-active');
      }
    }
  }

  function initLockScenes(scope) {
    var root = scope || document;
    var lockSections = root.querySelectorAll('.lock-scenes-2026__lock[data-lock-section]');

    if (!lockSections.length) {
      return;
    }

    var ticking = false;

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        lockSections.forEach(function (lockSection) {
          updateSection(lockSection);
        });
        ticking = false;
      });
    }

    lockSections.forEach(function (lockSection) {
      if (lockSection.dataset.lockBound === 'true') {
        return;
      }

      lockSection.dataset.lockBound = 'true';
      updateSection(lockSection);
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLockScenes(document);
    });
  } else {
    initLockScenes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLockScenes(event.target);
  });
})();
